import Dorothy from "../actors/Dorothy";
import common from "../common";
import ParticleEmitter from "../reusableModules/ParticleEmitter";
import MixingBowl from "./Stage_Mixing_Objects/MixingBowl";
import Primary_Ingredients from "./Stage_Mixing_Objects/SubStages/Primary_Ingredients";
import BaseStage from "./BaseStage";
import Gesture_Mixing from "./Stage_Mixing_Objects/SubStages/Gesture_Mixing";
import Secondary_Ingredients from "./Stage_Mixing_Objects/SubStages/Secondary_Ingredients";
import Dough from "./Stage_Cutting_Objects/Dough";

export default class Stage_Ingredients extends BaseStage {
    constructor() {
        super("mixing_1");
        this._primaryIngredients = null;
        this._secondaryIngredients = null;
        this._gestureMixing = null;

        this._isSecondaryComplete = false;

        this._mixingBowl = null;
        this._ingredientAddedEmitter = null;
        this._flourBurstEmitter = null;
        this._flourMixingEmitter = null;

        this._requiredItems = [];
        this._wantsItem = false;

        this._dorothy = null;
        this._dorothyThinkingReset = 10;
        this._dorothyThinkingTimer = this._dorothyThinkingReset;

        this._bindings = [];
        this._signals = {};
        this._signals._dorothySlideComplete = new P3.utils.MiniSignal();
    }

    init() {
        super.init(P3.audio.playMusic("music_ambient_music_loop_00"));

        //this.determineRequest();

        this._primaryIngredients = new Primary_Ingredients();
        this._primaryIngredients._bindings._dorothySlideComplete = this._signals._dorothySlideComplete.add(this._primaryIngredients.animateInIngredients, this._primaryIngredients);
        this._bindings.primaryIngredientRemoved = this._primaryIngredients._signals.ingredientRemoved.add(this.primaryIngredientRemoved, this);
        this._bindings.primaryStageComplete = this._primaryIngredients._signals.stageComplete.add(this.primaryStageComplete, this);
        this._primaryIngredients._bindings.help = this.signals.helpTutorial.add(()=>{
            this._primaryIngredients.createTutorial(true)
        }, this._primaryIngredients);


        this._secondaryIngredients = new Secondary_Ingredients(this._requiredItems);
        this._bindings.secondaryIngredientRemoved = this._secondaryIngredients._signals.ingredientRemoved.add(this.secondaryIngredientRemoved, this);
        this._bindings.secondaryStageComplete = this._secondaryIngredients._signals.stageComplete.add(this.secondaryStageComplete, this);

        this.createBackground();
        this.createMixingBowl();
        //console.log(this.children.length);

        this._primaryIngredients.init(this._mixingBowl._front.position);
        this.addChildAt(this._primaryIngredients, 5);
        this.addChild(this._secondaryIngredients);

        this.createUI();
        this._nextButtonClick.detach();
        this._nextStageButton.signals.click.add(this.slideOutDorothy, this);

        this.createEmitters();
    }

    appear() {
        super.appear();
    }

    animateIn() {
    }

    destroy() {
        for (const i in this._bindings) {
            if (this._bindings.hasOwnProperty(i)) {
                const binding = this._bindings[i];
                binding.detach();
            }
        }
        this._bindings = {};

        if(this._ingredientAddedEmitter != null)
            this._ingredientAddedEmitter.destroy();

        if(this._flourMixingEmitter != null)
            this._flourMixingEmitter.destroy();

        if(this._flourBurstEmitter != null)
            this._flourBurstEmitter.destroy();


        if(this._secondaryIngredients) {
            this.removeChild(this._secondaryIngredients);
            this._secondaryIngredients.destroy();
        }

        this._gestureMixing.destroy();
        this._mixingBowl.destroy(this);
        this._mixingBowl = null;


        // clean up goes here
        super.destroy();
    }

    resize() {
        super.resize();
    }

    update() {
        super.update();

        this.dorothyUpdate();
        this.emitterUpdate();

        if(this._mixingBowl)
            this._mixingBowl.update();

        if(this._primaryIngredients)
            this._primaryIngredients.update();

        if(this._gestureMixing)
            this._gestureMixing.update();

        if(this._secondaryIngredients)
            this._secondaryIngredients.update();

        if(this._flourMixingEmitter){
            this._flourMixingEmitter.y = this._mixingBowl._mixture.y;
        }
    }

    dorothyUpdate(){
        this._dorothy.update(P3.Ticker.dt);
        this._dorothyThinkingTimer -= P3.Ticker.dt;
        if(this._dorothyThinkingTimer < 0){
            this._dorothy.playDoughThinkingAnimaton();
            this._dorothyThinkingTimer = this._dorothyThinkingReset;
        }
    }

    emitterUpdate(){
        if(this._ingredientAddedEmitter)
            this._ingredientAddedEmitter.update(P3.Ticker.dt);

        if(this._flourBurstEmitter)
            this._flourBurstEmitter.update(P3.Ticker.dt);

        if(this._flourMixingEmitter)
            this._flourMixingEmitter.update(P3.Ticker.dt);
    }

    //=======================
    //DOROTHY
    //=======================

    createBackground(){
        this._dorothy = new Dorothy();
        this._dorothy.view.scale.set(0.6);
       // this._dorothy.position.set(common.STAGE_WIDTH * 0.5 + 1200, common.STAGE_HEIGHT * 0.5 + 325);
        this._dorothy.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 + 300, common.STAGE_HEIGHT * 0.5 + 325);
        this.addChildAt(this._dorothy, 0);
        this.slideInDorothy();

        let table = new PIXI.Sprite(P3.assets.texture('table'));
        table.anchor.set(0.5);
        table.scale.x = 2;
        table.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT + P3.View.height) * 0.5 - 100);
        this.addChildAt(table,1);

        let bk = new PIXI.Sprite(P3.assets.texture('bg_kitchen'));
        bk.anchor.set(0.5);
        bk.width = 1900;
        bk.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChildAt(bk, 0);
    }

    slideInDorothy(){
        let onStart = ()=>{
            this._dorothy.playJumpInAnimation();
            P3.audio.playSound("sfx_dorothy_jump_in_00");
        };
        let onComplete = ()=>{
            this._dorothy.playDoughThinkingAnimaton();
            this._primaryIngredients._ingredients[0]._animIn.onComplete(()=>{
                this._dorothy.playHappAnimation(common.getRandomInt(1,3));
            });
            this._signals._dorothySlideComplete.dispatch();
            // for (let i = 0; i < this._primaryIngredients._ingredients.length; i++) {
            //     const argument = this._primaryIngredients._ingredients[i]._animIn;
            //     argument.start();
            // }
        };

        this._dorothy.slideInDorothy(this.tweens, common.STAGE_WIDTH * 0.5 + 350, onStart, onComplete).start();
       // this._dorothy.slideInDorothy(this.tweens, common.STAGE_WIDTH * 0.5 + 350, onStart, onComplete).start();
    }

    slideOutDorothy(){
        new P3.utils.TWEEN.Tween(this._dorothy, this.tweens)
            .to({
                x: (common.STAGE_WIDTH + P3.View.width) * 0.5 + 300
            }, 750)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .delay(0)
            .onStart(() => {
                this._dorothy.playJumpOutAnimation();
            })
            .onComplete(()=>{
                this.signals.next.dispatch();
            })
            .start();
    }

    //=======================
    //Mixing Bowl
    //=======================

    createMixingBowl(){
        this._mixingBowl = new MixingBowl(this);
        this._bindings._bowlUp = this._mixingBowl._signals._bowlUpComplete.add(this.onBowlUpComplete, this);
        this._bindings._bowlDown = this._mixingBowl._signals._bowlDownComplete.add(this.onBowlDownComplete, this);
    }

    onBowlUpComplete(){
       // console.log("bowl up");
        this._bindings._bowlUp.detach();
        this._gestureMixing = new Gesture_Mixing();
        this._gestureMixing.init();
        this.addChild(this._gestureMixing);

        this._bindings.gestureComplete = this._gestureMixing._signals.gestureComplete.add(this.gestureComplete, this);
        this._gestureMixing._bindings.help = this.signals.helpTutorial.add(()=>{
            this._gestureMixing.createTutorial(true)
        }, this._gestureMixing);

        this._dorothy.playContinousMixing();
    }

    onBowlDownComplete(){
        this._bindings._bowlDown.detach();
        if(!this._isSecondaryComplete){
            this._helpStage = "mixing_3";

            this._secondaryIngredients.init(this._mixingBowl._front.position);

            this._secondaryIngredients._bindings.help = this.signals.helpTutorial.add(()=>{
                this._secondaryIngredients.createTutorial(true)
            }, this._secondaryIngredients);

            this.removeChild(this._gestureMixing);
            this._gestureMixing.destroy();

            this.removeChild(this._primaryIngredients);
            this._primaryIngredients.destroy();

            this._gestureMixing = null;
            this._primaryIngredients = null;
        }
    }

    primaryIngredientRemoved(){
        this._mixingBowl._animateWhisk = true;
        this._mixingBowl._mixture.animateMixtureRise();
        this._mixingBowl._mixture.changeColour("0xFEF7D6");
        this._flourBurstEmitter.play();

        this._ingredientAddedEmitter.play();

        this._dorothyThinkingTimer = this._dorothyThinkingReset;
        this._dorothy.playHappAnimation(common.getRandomInt(1,3));
    }

    secondaryIngredientRemoved(colour){
        this._mixingBowl._animateWhisk = true;
        this._mixingBowl._mixture.animateMixtureRise();

        this._mixingBowl._mixture.changeColour(colour);
        let con = this._flourMixingEmitter._emitter.startColor;
        con.value = this._mixingBowl._mixture.convertHex(this._mixingBowl._mixture.nextColour);
        this._flourMixingEmitter.play();

        if(colour === Dough.DARK || colour === Dough.WHITE || colour === Dough.RAISEN){
            common.doughIngredient = colour;
        }else if (colour === Dough.STRAWBERRY){
            common.doughIngredient = colour;
            common.doughColour = colour;
        }else{
            common.doughColour = colour;
        }

        this._ingredientAddedEmitter.play();
        this._dorothyThinkingTimer = this._dorothyThinkingReset;
        this._dorothy.playHappAnimation(common.getRandomInt(1,3));
    }

    //========================
    //PARTICLE SETUP
    //========================

    createEmitters(){

        let emitter = (particleData, particleTextures, position)=>{
            let emitter = new ParticleEmitter(particleData, particleTextures, true);
            emitter.position.set(position.x, position.y);
            this.addChildAt(emitter, 4);
            return emitter;
        };

        this._flourMixingEmitter = emitter(ParticleEmitter.BOWL_FLOUR_MIXING_00, ParticleEmitter.FLOUR_CLOUD,
            {x: common.STAGE_WIDTH * 0.5 - 5, y: common.STAGE_HEIGHT * 0.5 + 115});
        let config = this._flourMixingEmitter._config;
        config.scale = {
            "start": 0.41,
            "end": 2,
            "minimumScaleMultiplier": 0.9
        };
        this._flourMixingEmitter.overrideDefaultConfig(config);

        this._ingredientAddedEmitter = emitter(ParticleEmitter.BOWL_FLAVOURS_BURST_00, ParticleEmitter.SPARKLE, {x: common.STAGE_WIDTH * 0.5 - 5, y: common.STAGE_HEIGHT * 0.5 + 275});

        this._flourBurstEmitter = emitter(ParticleEmitter.BOWL_FLOUR_BURST_00, ParticleEmitter.FLOUR_CLOUD,
            {x: common.STAGE_WIDTH * 0.5 - 5, y: common.STAGE_HEIGHT * 0.5 + 275});
        config = this._flourBurstEmitter._config;
        config.scale = {
            "start": 0.5,
            "end": 1,
            "minimumScaleMultiplier": 0.7
        };
        this._flourBurstEmitter.overrideDefaultConfig(config);
    }

    primaryStageComplete(){
        //console.log("Primary Finished");
        this._bindings.primaryStageComplete.detach();
        this._mixingBowl._animateUp = true;
        this._helpStage = "mixing_2";
    }

    secondaryStageComplete(){
        //console.log("Secondary Finished");
        this._bindings.secondaryStageComplete.detach();
        this._bindings._bowlUp = this._mixingBowl._signals._bowlUpComplete.add(this.onBowlUpComplete, this);
        this._bindings._bowlDown = this._mixingBowl._signals._bowlUpComplete.add(this.onBowlDownComplete, this);
        this._mixingBowl._animateUp = true;
        this._isSecondaryComplete = true;

        for (let i = 0; i < this._secondaryIngredients._ingredients.length; i++) {
                const temp = this._secondaryIngredients._ingredients[i];
                temp._completed = true;
                temp.floatBackAnimation();
        }
        this._helpStage = "mixing_2";
    }

    gestureComplete(){
        //console.log("gesture complete");
        if(this._isSecondaryComplete){
            new P3.utils.TWEEN.Tween(this, this.tweens)
                .to({

                }, 0)
                .easing(P3.utils.Easing.Back2.Out)
                .delay(2000)
                .onComplete(()=>{
                    this.slideOutDorothy();
                    //P3.audio.playSound("sfx_stage_complete_00");
                })
                .start();
            this._dorothyThinkingTimer = this._dorothyThinkingReset;
            this._dorothy.playHappAnimation(common.getRandomInt(1,3));
        }else{
            this._mixingBowl._animateDown = true;
            this._mixingBowl._whisk._continueMixing = false;
        }
    }

    determineRequest(){
        let request = common.selectedCharacter.getRequest();
        if(request.type !== "ingredient") return;

        this._requiredItems = request.requestedParts.slice();
        this._wantsItem = request.wants;
    }
}